import { useCallback } from 'react';
import { useGetReminderDateTime } from '../../../components';
import type { EditEventRequest } from '../../../queries';
import type { EditReminderFormValues } from '../EditReminderForm';

export const useCreateFormRequestData = () => {
  const getReminderDateTime = useGetReminderDateTime();

  return useCallback(
    (formValues: EditReminderFormValues, eventId: string): EditEventRequest => {
      const { endTime, startTime } = getReminderDateTime(formValues);

      return {
        data: {
          allDay: formValues.isAllDay,
          endTime: endTime.toISOString(),
          html: formValues.htmlDescription,
          name: formValues.name,
          startTime: startTime.toISOString(),
          text: formValues.textDescription,
          type: 'reminder',
        },
        eventId,
      };
    },
    [getReminderDateTime],
  );
};
